import { Icon } from './icons'
import type { Server } from './types'

interface BottomNavProps {
  route: string
  servers: Server[]
  setRoute: (route: string) => void
  onMoreClick: () => void
}

interface Slot {
  id: string
  label: string
  icon: string
  match: (route: string) => boolean
  go: () => void
}

export function BottomNav({ route, servers, setRoute, onMoreClick }: BottomNavProps) {
  const firstServer = servers[0]
  const slots: Slot[] = [
    {
      id: 'dashboard',
      label: 'Home',
      icon: 'layout-dashboard',
      match: r => r === 'dashboard',
      go: () => setRoute('dashboard'),
    },
    {
      id: 'servers',
      label: 'Servers',
      icon: 'server',
      match: r => r.startsWith('srv:'),
      go: () => firstServer && setRoute(`srv:${firstServer.id}`),
    },
    {
      id: 'players',
      label: 'Players',
      icon: 'users',
      match: r => r === 'players',
      go: () => setRoute('players'),
    },
    {
      id: 'plugins',
      label: 'Plugins',
      icon: 'puzzle',
      match: r => r === 'plugins',
      go: () => setRoute('plugins'),
    },
    {
      id: 'more',
      label: 'More',
      icon: 'menu',
      match: r => r === 'audit' || r === 'backups' || r === 'settings',
      go: onMoreClick,
    },
  ]

  return (
    <nav className="bottom-nav">
      {slots.map(slot => {
        const active = slot.match(route)
        const disabled = slot.id === 'servers' && !firstServer
        return (
          <button
            key={slot.id}
            className={`bn-item ${active ? 'active' : ''}`}
            onClick={slot.go}
            disabled={disabled}
            aria-label={slot.label}
          >
            <Icon name={slot.icon} size={20} className="bn-ico" />
            <span className="bn-label">{slot.label}</span>
          </button>
        )
      })}
    </nav>
  )
}
